import checkAge from './checkAge';
import driverPromoPage from './driverPromoPage';
import admin from './admin';

export const en = {
  checkAge,
  driverPromoPage,
  admin,
};
